import React, {useState, useEffect, useRef} from 'react';
import './SearchBox.scss';
import { useTranslation } from 'react-i18next';

function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(
      initialIsVisible
    );
    const ref = useRef(null);
  
    const handleHideDropdown = (event) => {
      if (event.key === "Escape") {
        setIsComponentVisible(false);
      }
    };
  
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsComponentVisible(false);
      }
    };
  
    useEffect(() => {
      document.addEventListener("keydown", handleHideDropdown, true);
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("keydown", handleHideDropdown, true);
        document.removeEventListener("click", handleClickOutside, true);
      };
    });
  
    return { ref, isComponentVisible, setIsComponentVisible };
  }



function SearchBox({optionItems, parentCallback, isMandatory, isEnabled, headerLabel, isWarning, isDataLoading}) {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState("");

    const {ref, isComponentVisible, setIsComponentVisible} = useComponentVisible(false);

    const handleChange = e => {
        setSearchTerm(e.target.value);
    };
    
    const filteredItems = optionItems && optionItems.filter(item =>
        item.Label.toLowerCase().includes(searchTerm.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
    );    

    function headerClick() {
      if(!isComponentVisible){
        setSearchTerm("");
      }
      else{
      }
        setIsComponentVisible(!isComponentVisible);
    }

    function itemClick(item) {
        setIsComponentVisible(false);
        parentCallback(item);
    }

    return(
        <div ref={ref} className="search-box">
            <div className={`search-header ${isEnabled ? (isDataLoading? 'loading' : ''):'disabled'} ${isWarning ? 'warning':''}`}
                 onClick={e => headerClick()}>
                {isMandatory ? <span className={`search-header__mandatory ${isEnabled ? (!(filteredItems)? 'loading' : 'enabled') :'disabled'} ${isWarning ? 'warning':''}`}>*</span> : ''}
                <span className={`search-header__label ${isEnabled ? (!(filteredItems)? 'loading' : 'enabled') :'disabled'} ${isWarning ? 'warning':''}`}>{headerLabel}</span>
            </div>
            {
                !(filteredItems) ? '' : isComponentVisible && (
                <div className="search-list">
                    {
                        ([...optionItems].length > 7) ?
                        <div className="search-list__input-container">
                            <input className="search-list__input-container__input" type="text" placeholder="Search" onChange={e => handleChange(e)}></input>
                            <span className="search-list__input-container__mglass search-list__input-container__ico-mglass"></span>
                        </div>
                        : ''
                    }
                    <div className="search-list__scroll">
                        {
                            (filteredItems.length) ?
                            <ul className="search-list__scroll__recovered-items">
                                {filteredItems.map(item => (
                                    <li className="search-list__scroll__recovered-items__item"
                                        key = {item.Value}
                                        onClick={e => itemClick(item)}> 
                                        <span>{item.Label}</span>
                                    </li>
                                ))}
                            </ul> :
                            <div className="search-list__scroll__resultless">
                                <span>{t('warning_message_part1')} <b>"{searchTerm.length > 19 ? searchTerm.substring(0,19) + "..." : searchTerm}"</b>{t('warning_message_part2')}</span>
                            </div>
                        }
                    </div>
                </div>     
              )
            }
        </div>  
    );
}

export default SearchBox;